export default __webpack_public_path__ + "static/media/downred_transparent.479b0a05.png";